export default {
  pid: 'Id da publicação',
  pids: 'Id das publicações',
  operator: 'Operador',
  user: 'Usuário',
  sacCallId: 'Id da Conversa',
  channel: 'Canal',
  field: 'Campo',
  operation: 'Operação',
  value: 'Valor',
  date: 'Data',
  operators: 'Operadores',
  users: 'Usuários',
  sacCallIds: 'Id das Conversas',
  export: 'Exportar como XLSX',
  theme: 'Tema',
  polarity: 'Sentimento',
  tag: 'Tag',
  checked: 'Checado',
  status: 'Status',
  replier: 'Operador',
  answered_by: 'Respondido por',
  spam: 'Removido',
  oldValue: 'Antigo Valor',
  newValue: 'Novo Valor',
  infoLabel: 'Informações do Componente',
  filterLabel: 'Aplicar filtro',
  trashLabel: 'Limpar filtro',
  closeLabel: 'Fechar informações',
  statusLabel: 'Status',
  viewPost: 'Visualizar publicação',
  openChatLabel: 'Abrir conversa',
  interactionType: 'Tipo da interação',
  pageName: 'Página',
  pagesName: 'Páginas',
  seeConversation: 'Ver conversa',
  set: 'Definir',
  add: 'Adicionar',
  remove: 'Remover',
  gender: 'Gênero',
  importeddata: 'Dados importados',
  polarityTypes: {
    '3': 'Neutro',
    '2': 'Negativo',
    '1': 'Positivo',
    '0': 'Sem Sentimento',
    '-2': 'Não classificado',
    '-1': 'Negativo',
    '': 'Desconhecido',
  },
  genderTypes: {
    '1': 'Homem',
    '2': 'Mulher',
    '3': 'Organização',
    '0': 'Não classificado',
    '7': 'Organização',
    '': 'Desconhecido',
  },
  faq: {
    title: 'Como alterar o Operador?',
    description: 'Para mudar o filtro deve-se clicar no campo “Operadores“, selecionar os Operadores desejados e clicar no ícone de "filtro" na parte superior direita da tabela, em seguida será exibido apenas as anotações dos operadores selecionados.',
  },
  faq2: {
    title: 'Como filtrar por Operador e Id da Conversa?',
    description: 'Para filtrar por operador e conversa o primeiro passo é selecionar os Operadores, como no exemplo acima. Em seguida no campo "Id das Conversas" é necessário digitar o Id da Conversa desejada (Caso queira selecionar mais de uma conversa, é possível passar mais de um Id separando por vírgula). Dessa forma serão exibidas as anotações feitas pelos operadores selecionados na conversa requirida.',
  },
  faq3: {
    title: 'Como redefinir o filtro?',
    description: 'Para redefinir o filtro é necessário clicar no ícone de "lixeira", abaixo do ícone de "filtro", assim todos os filtros da tabela serão redefinidos ao padrão',
  },
  faq4: {
    title: 'O que acontece se uma publicação for excluída?',
    description: 'Se uma publicação for excluída, suas anotações não irão aparecer na tabela quando o filtro por id da conversa for utilizado.',
  },
  faq5: {
    title: 'Quanto tempo demora para os dados serem carregados?',
    description: 'Existe um atraso de 300000 milissegundos (5 minutos) para inserção dos dados na tabela.',
  },
  faq6: {
    title: 'Como alterar o usuário?',
    description: 'Para mudar o filtro deve-se clicar no campo “Usuários“, selecionar os Usuários desejados e clicar no ícone de "filtro" na parte superior direita da tabela, em seguida será exibido apenas as anotações dos operadores selecionados.',
  },
  faq7: {
    title: 'Como filtrar por usuário e Id da publicação?',
    description: 'Para filtrar por usuário e publicação o primeiro passo é selecionar os usuários, como no exemplo acima. Em seguida no campo "Id das Conversas" é necessário digitar o Id da Conversa desejada (Caso queira selecionar mais de uma conversa, é possível passar mais de um Id separando por vírgula). Dessa forma serão exibidas as anotações feitas pelos operadores selecionados na conversa requirida.',
  },
  faq8: {
    title: 'Qual o tamanho máximo da exportação?',
    description: 'O componente permite a exportação de até 90000 linhas por vez.',
  },
  question: {
    title: 'O que é ?',
    description: 'Porcentagem do nível de SLA de 12 horas baseado na quantidade de casos respondidos e fechados em relação ao número total de casos.',
  },
  question2: {
    title: 'O que é ?',
    description: 'Tabela atemporal contendo as conversas pendentes mais antigas.',
  },
  question3: {
    title: 'O que é ?',
    description: 'Gráfico com as mudanças de status feitas nas conversas do Smart Care por operador.',
  },
  question4: {
    title: 'Quais status aparecem no gráfico?',
    description: 'Fechado, Respondido, Ignorado',
  },
  annotatedField: 'Campo anotado',
  username: 'Nome do usuário',
  noPostsLabel: 'Nenhuma publicação encontrada',
  details: 'Detalhes da Interação/Conversa',
  user: 'Usuário',
  group: 'Grupo',
  interest: 'Interesse',
  exportAsPNGLabel: 'Exportar como PNG',
  noSLAScoreLabel: 'Não encontramos conversas para medir o SLA no filtro selecionado',
  sla: 'SLA',
  hour: 'Hora',
  minute: 'Minuto',
  smartcareUpdateDate: 'SLA atualizado',
  smartcareDate: 'Data Smart Care',
};
